import axios, { AxiosInstance } from "axios";
import { attachMicrosoftEntraBearer } from "./attachMicrosoftEntraBearer";

axios.defaults.withCredentials = true;

export const kbAxiosInstance: AxiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_KB_API_ENDPOINT || 'https://searchknowledgebase.talentica.com/api',
  headers: {
    "Content-type": "application/json",
  },
});

// Request interceptor - add auth token
kbAxiosInstance.interceptors.request.use(
  (config) => {
    attachMicrosoftEntraBearer(config);
    // Remove Content-Type header for FormData - browser will set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers["Content-type"];
      delete config.headers["Content-Type"];
      // Ensure axios doesn't serialize FormData
      config.transformRequest = [(data) => data];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
kbAxiosInstance.interceptors.response.use(
  (res) => {
    if (res.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/login';
    }
    return res;
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);
